<template>
  <div class="echarts">
    <IEcharts :option="bar" :loading="loading" />
  </div>
</template>

<script>
import IEcharts from "vue-echarts-v3/src/full.js";
export default {
  name: "CloseTasksChart",
  components: {
    IEcharts
  },
  props: {
    DetailParams: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    loading: true,
    bar: {
      title: {
        text: "Gráfico Detalle de Cierres de tareas"
      },
      tooltip: {},
      xAxis: {
        data: [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31"
        ]
      },
      yAxis: {},
      series: [
        {
          name: "Dia : Cantidad de Cierres",
          type: "line",
          data: []
        }
      ]
    }
  }),
  created() {
    this.getChartData();
  },
  methods: {
    async getChartData() {
      const that = this;
      await this.$http
        .get("/api/CMI/Task/GetTaskMonthChart", {
          params: {
            employeeId: this.DetailParams.EmployeeId,
            year: this.DetailParams.Year,
            month: this.DetailParams.Month
          }
        })
        .then((resp) => {
          that.bar.series[0].data = Object.values(resp.data);
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 93%;
  height: 400px;
  background-color: #f3f7fa;
  border-radius: 30px;
  margin: 30px;
  padding: 10px;
}
</style>
